const anchorMenus = document.querySelectorAll('.anchor-menu');
const mainSections = document.querySelectorAll('main section[id]');

anchorMenus.forEach((menu) => {
	const scrollDiv = menu.querySelector('.overflow-parent');
	const overflowGradient = scrollDiv.querySelector('[data-overflow-gradient]');
	const menuItems = menu.querySelectorAll('a');
	const mobileSelect = menu.querySelector('select');
	const currentHash = window.location.hash.split('#')[1];

	const updateOverflowGradient = () => {
		if (scrollDiv.scrollLeft > 0) {
			overflowGradient.classList.add('hidden');
		} else {
			overflowGradient.classList.remove('hidden');
		}
	};

	scrollDiv.addEventListener('scroll', () => {
		scrollDiv.classList.add('is-scrolled');
		updateOverflowGradient();
	});

	updateOverflowGradient();

	document.addEventListener('scrollend', (e) => {
		let scrollTrigger = true;

		mainSections.forEach((section) => {
			const top = section.getBoundingClientRect().top + document.documentElement.scrollTop - menu.offsetHeight;
			const bottom = section.getBoundingClientRect().bottom + document.documentElement.scrollTop;
			const activeItem = menu.querySelector('a[href="#' + section.id + '"]');
			const marginTop = parseInt(getComputedStyle(section).marginTop);
			const correctedTop = top - marginTop - menu.offsetHeight;

			if (window.scrollY < menu.getBoundingClientRect().top) {
				menuItems.forEach((item) => item.classList.remove('is-active'));
				menuItems[0].classList.add('is-active');
				mobileSelect.value = menuItems[0].href.split('#')[1];
			} else if (correctedTop <= window.scrollY && window.scrollY <= bottom) {
				if (activeItem && activeItem.classList.contains('is-active')) {
					scrollTrigger = false;
				}

				menuItems.forEach((item) => item.classList.remove('is-active'));
				activeItem.classList.add('is-active');
				mobileSelect.value = activeItem.href.split('#')[1];

				if (scrollTrigger) {
					scrollDiv.scrollTo({
						left: activeItem.offsetLeft,
						behavior: 'smooth',
					});
				}
			}
		});
	});

	menuItems.forEach((item) => {
		item.addEventListener('click', () => {
			const anchorID = item.href.split('#')[1];
			mobileSelect.value = anchorID;
			menuItems.forEach((sibling) => sibling.classList.remove('is-active'));
			item.classList.add('is-active');
		});
	});

	mobileSelect.addEventListener('change', () => {
		window.location.hash = mobileSelect.value;
		document.getElementById(mobileSelect.value)?.focus();
	});

	// Pre-load select if hash is present in URL
	if (currentHash) {
		mobileSelect.value = currentHash;
	}
});
